import { render, staticRenderFns } from "./r-shared-config-view.vue?vue&type=template&id=38bc4643"
import script from "./r-shared-config-view.vue?vue&type=script&lang=js"
export * from "./r-shared-config-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bc4643')) {
      api.createRecord('38bc4643', component.options)
    } else {
      api.reload('38bc4643', component.options)
    }
    module.hot.accept("./r-shared-config-view.vue?vue&type=template&id=38bc4643", function () {
      api.rerender('38bc4643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/shared-config/r-shared-config-view.vue"
export default component.exports